import CoverLayout from './CoverLayout';


export default CoverLayout;
